import axios from "axios";
import qs from "qs";

// 旧的用于请求C#服务器
const oldService = axios.create({
  baseURL: "$__BASE_URL_NAPI/",
  withCredentials: true,
});

oldService.interceptors.request.use(
  (config) => {
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    return config;
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  },
);

// 新 的用于请求Java服务器
const service = axios.create({
  baseURL: "$__BASE_URL_API/",
  withCredentials: true,
});

service.interceptors.request.use(
  (config) => {
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    return config;
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  },
);

export default {
  service,
  oldService,
};



// WEBPACK FOOTER //
// ./src/utils/request.js